import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { message } from 'ant-design-vue';
import {
  confirm_product_out_cancel_record,
  get_product_in_record_by_out,
} from '@/api/mjstock-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { reactive } from 'vue';
// import { update_require_info } from '@/api/mjstore-model';
import modalBox from '@/components/form-modal/modal-tools';
import base_info from '@/components/info-modal/base_info_modal';

export const event_obj = mitt();
export const btn_list = [
  // {
  //   name: '作废',
  //   clazz: 'danger',
  //   is_show: (record: any) => {
  //     return record.is_active && record.in_type != 3;
  //   },
  //   cb: (record: any) => {
  //     Modal.confirm({
  //       title: '提示',
  //       content: '是否作废这条记录[' + record.code + ']',
  //       onOk() {
  //         delete_product_out_cancel_record({
  //           product_out_cancel_record_id: record.id,
  //           org_id: current_org?.id,
  //         }).then(function (res) {
  //           message.success('作废成功');
  //           Object.assign(record, res);
  //         });
  //       },
  //       onCancel() {},
  //     });
  //   },
  // },
  {
    name: '确认已入库',
    clazz: 'primary',
    is_show: (data: any) => {
      if (!data.confirm_in_stock && data.is_active) {
        return true;
      }
    },
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '确认已入库',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {
            shop_id: [{ required: true, message: '请选择执行门店' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            product_out_cancel_record_id: data.id,
            shop_id: current_shop?.id,
            staff_id: null,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            confirm_product_out_cancel_record(payload)
              .then(() => {
                message.success('确认已入库成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '详情',
    clazz: '',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: (record: any) => {
      // 模态框，确认按钮点击。
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      get_product_in_record_by_out({
        org_id: current_org?.id,
        product_out_record_id: record.product_out_record_id,
      }).then(function (res: any) {
        base_info(
          '入库产品信息',
          '入库编号:' + res.code,
          [
            { name: '产品编号', value: 's_product__code' },
            { name: '产品名称', value: 's_product__name' },
            { name: '产品规格', value: 's_product__gg' },
            { name: '产品单位', value: 's_product__dw' },
            { name: '产品批次', value: 'product_code' },
            { name: '产品单价', value: 'single_price' },
            { name: '生产日期', value: 'product_date' },
            { name: '到期日期', value: 'end_date' },
            { name: '厂商', value: 'product_company__name' },
            { name: '供货商', value: 'supply_company__name' },
          ],
          res,
        );
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
